class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.announcementBar = this.querySelector("[data-announcement-container]");
    this.rotationInterval = Number(this.announcementBar?.dataset.rotationInterval) || 5000;
    this.announcementInterval = null;

    this.changeAnnouncement = this.changeAnnouncement.bind(this);
    this.previousAnnouncement = this.previousAnnouncement.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.hideForOneDay = this.hideForOneDay.bind(this);
    this.restartInterval = this.restartInterval.bind(this);
    this.isMobileView = this.isMobileView.bind(this);
  }

  connectedCallback() {
    this.totalSlides = this.announcementBar?.children.length || 0;

    if (!this.announcementBar?.classList.contains("wt-announcement__container--marquee")) {
      if (this.totalSlides > 1 && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.announcementInterval = setInterval(this.changeAnnouncement, this.rotationInterval);
      }

      if (this.announcementBar) {
        this.announcementBar.addEventListener(
          "touchstart",
          this.handleTouchStart,
          { passive: true },
        );
        this.announcementBar.addEventListener(
          "touchmove",
          this.handleTouchMove,
          {
            passive: true,
          },
        );
        this.announcementBar.addEventListener("touchend", this.handleTouchEnd, {
          passive: true,
        });
        this.announcementBar.addEventListener(
          "touchstart",
          () => clearInterval(this.announcementInterval),
          { passive: true },
        );
        this.announcementBar.addEventListener(
          "touchend",
          this.restartInterval,
          {
            passive: true,
          },
        );
      }
    }

    if (this.announcementBar)
      this.announcementBar.style.transition = "transform 0.5s ease-in-out";

    this.closeButton = this.querySelector(".wt-announcement__close");
    if (this.closeButton)
      this.closeButton.addEventListener("click", this.hideForOneDay);

  }

  isMobileView() {
    return window.innerWidth < 900;
  }

  restartInterval() {
    clearInterval(this.announcementInterval);
    if (this.totalSlides > 1 && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.announcementInterval = setInterval(this.changeAnnouncement, this.rotationInterval);
    }
  }

  hideForOneDay() {
    const oneDayLater = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem(this.dataset.hiddenStorageKey, oneDayLater);
    this.style.display = "none";
  }

  changeAnnouncement() {
    if (this.totalSlides < 2) return;

    // Move to the next slide
    this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
    const newPosition = -(this.currentIndex * 100);

    if (this.announcementBar)
      this.announcementBar.style.transform = `translateX(${newPosition}%)`;
  }

  previousAnnouncement() {
    if (this.totalSlides < 2) return;
    this.currentIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
    const newPosition = -(this.currentIndex * 100);
    if (this.announcementBar)
      this.announcementBar.style.transform = `translateX(${newPosition}%)`;
  }

  handleTouchStart(e) {
    if (this.isMobileView()) {
      this.touchStartX = e.touches[0].clientX;
    }
  }

  handleTouchMove(e) {
    if (this.isMobileView()) {
      this.touchEndX = e.touches[0].clientX;
    }
  }

  handleTouchEnd() {
    const swipeThreshold = 30;

    if (Math.abs(this.touchEndX - this.touchStartX) > swipeThreshold) {
      if (this.touchEndX < this.touchStartX) {
        this.changeAnnouncement();
      } else {
        this.previousAnnouncement();
      }
    }
  }

  disconnectedCallback() {
    clearInterval(this.announcementInterval);
    if (!this.announcementBar) return;
    this.announcementBar.removeEventListener(
      "touchstart",
      this.handleTouchStart,
    );
    this.announcementBar.removeEventListener("touchmove", this.handleTouchMove);
    this.announcementBar.removeEventListener("touchend", this.handleTouchEnd);
  }
}

if (!customElements.get("announcement-bar")) {
  customElements.define("announcement-bar", AnnouncementBar);
}
